import "./modalCarousel.css";

import React, { useEffect, useState } from "react";
import YoutubeVideo from "../../YoutubeVideo/YoutubeVideo";

function ModalCarousel({
  src,
  selectDataIndex,
  data,
  openModalCarousel,
  handleCloseModalCarousel,
}) {
  const [modalCarouselImageIndex, setModalCarouselImageIndex] =
    useState(selectDataIndex);

  useEffect(() => {
    setModalCarouselImageIndex(selectDataIndex);
  }, [selectDataIndex, openModalCarousel]);

  const currentItem = data?.[modalCarouselImageIndex];
  const currentImageSrc = src ? currentItem : currentItem?.src;

  const handleNext = () => {
    if (modalCarouselImageIndex < data.length - 1) {
      setModalCarouselImageIndex(modalCarouselImageIndex + 1);
    } else {
      setModalCarouselImageIndex(0);
    }
  };

  const handlePrev = () => {
    if (modalCarouselImageIndex > 0) {
      setModalCarouselImageIndex(modalCarouselImageIndex - 1);
    } else {
      setModalCarouselImageIndex(data.length - 1);
    }
  };

  if (!data || !data.length) {
    return null;
  }

  return (
    <div className="modal-carousel-container" role="dialog" aria-modal="true">
      <div
        className={`images-detail-main ${
          openModalCarousel ? "open-modal" : "out-modal"
        }`}
      >
        <div className="images-detail-topbar">
          <span className="images-detail-counter">
            {modalCarouselImageIndex + 1} / {data.length}
          </span>
          <button
            type="button"
            className="images-detail-close"
            onClick={handleCloseModalCarousel}
            aria-label="Close modal"
          >
            <span className="material-symbols-outlined">close</span>
          </button>
        </div>

        <div className="modal-image-box">
          {src ? (
            <img src={currentImageSrc} alt="modal content" className="modal-img" />
          ) : currentItem?.type === "video" ? (
            currentItem.duration ? (
              <div className="modal-video-box">
                <YoutubeVideo
                  videoId={currentItem.src}
                  autoplay={true}
                  mute={false}
                />
              </div>
            ) : (
              <video src={currentItem.src} autoPlay controls />
            )
          ) : (
            <img
              src={currentItem?.src}
              alt="modal content"
              className="modal-img"
            />
          )}
        </div>

        <button
          type="button"
          className="images-detail-button-prev"
          onClick={handlePrev}
          aria-label="Previous"
        >
          <span className="material-symbols-outlined">arrow_back_ios_new</span>
        </button>
        <button
          type="button"
          className="images-detail-button-next"
          onClick={handleNext}
          aria-label="Next"
        >
          <span className="material-symbols-outlined">arrow_forward_ios</span>
        </button>
      </div>
    </div>
  );
}

export default ModalCarousel;
